<template>
    <div class="overlay_comp_wrap schedule_code top" v-if="isShow">
        <div class="overlay_comp_title">
            {{ $t('work_schedule.filter_overlay.title') }}
            <a class="mgl_auto" @click="action_CloseOverlay">
                <v-icon>mdi-close</v-icon>
            </a>
        </div>
        <div class="overlay_comp_desc">
            <v-icon>mdi-alert-circle-outline</v-icon>
            <div>{{ $t('work_schedule.filter_overlay.tooltip') }}</div>
        </div>
        <div class="overlay_comp_cont">
            <ul class="overlay_comp_list">
                <StateFilterItem v-for="(code, index) in workCodes" :key="index" :value="code"
                                 @selectCode="selectCode"/>
            </ul>
        </div>
    </div>
</template>

<script>
import StateFilterItem from './Items/StateFilterItem.vue'

export default {
    components: {StateFilterItem},
    props: {
        isShow: Boolean,
        workCodes: Array
    },
    data() {
        return {}
    },
    methods: {
        action_CloseOverlay() {
            this.$emit('hideOverlay', undefined)
        },
        selectCode(item) {
            this.$emit('selectCode', item)
        }
    }
}

</script>